import { PreloaderBackgroundType } from '../../constants/PreloaderBackgroundType';
import { CacheRepository } from '../../cache/iCacheRepository';
import { LocalStorageCache } from '../../cache/localStorageCache';
import { PreloaderBackgroundParams } from '../../constants/PreloaderBackgrounds';
import { CacheKeys } from '../../cache/cacheKeys';

export class PreloaderScreen {
    private static instance: PreloaderScreen;
    private hintBlocked: boolean = false;
    private storage: CacheRepository;
    private preloaderBackgrounds: PreloaderBackgroundParams;
    private currentType: PreloaderBackgroundType;
    private preloaderContainer: JQuery;

    private constructor() {
        this.storage = new LocalStorageCache();
        this.setPreloaderBackgroundParams();
        this.preloaderContainer = $('.game-loading-screen__newbie-video');
        this.createPreloaderBackground();
    }

    public static getInstance(): PreloaderScreen {
        if (typeof PreloaderScreen.instance === 'undefined') {
            PreloaderScreen.instance = new PreloaderScreen();
        }

        return PreloaderScreen.instance;
    }

    public showFirstSessionWarning() {
        $('.game-loading-screen__first-launch').show();
    }

    public showPreloader() {
        this.preloaderContainer.fadeIn();
    }

    public removePreloader() {
        this.preloaderContainer.empty();
    }

    public show() {
        $('.game-loading-screen').fadeIn();
    }

    public hide() {
        $('.game-loading-screen').fadeOut();
    }

    public setLoadingProgress(percent: number) {
        $('.game-loading-progress-bar__progress-percents').text(`${percent.toFixed()}%`);
        $('.game-loading-progress-bar__progress-bar').css('width', `${percent.toFixed()}%`);
    }

    public setHintText(text: string) {
        if (this.hintBlocked !== true) {
            $('.game-loading-indicator__hint-aligner').text(text);
        }
    }

    public setBackground(preloaderType: PreloaderBackgroundType) {
        if (preloaderType !== this.currentType) {
            this.setPreloaderBackgroundParams(preloaderType);
            this.createPreloaderBackground();
        }
    }

    public blockHintText() {
        this.hintBlocked = true;
    }

    private setPreloaderBackgroundParams(preloaderType?: PreloaderBackgroundType) {
        const cachedPreloaderType = this.getCachedPreloaderType();
        const preloaderBackgrounds = window.app.config.preloader_backgrounds;
        const backgroundType = preloaderType && preloaderBackgrounds[preloaderType]
            ? preloaderType
            : cachedPreloaderType;

        if (!preloaderBackgrounds[backgroundType]) {
            return;
        }

        this.savePreloaderTypeToCache(backgroundType);

        this.preloaderBackgrounds = preloaderBackgrounds[backgroundType];
    }

    private createPreloaderBackground() {
        if (typeof this.preloaderBackgrounds === 'undefined') {
            throw new Error('Preloader backgrounds not found');
        }

        this.removePreloader();
        if (this.preloaderBackgrounds.type === 'image') {
            const src = this.preloaderBackgrounds.htmlParams[0].src;
            const preloaderImage = $('<div>');
            preloaderImage.addClass('preloader_image');
            preloaderImage.css('background-image', `url(${src})`);
            this.preloaderContainer.append(preloaderImage);
        } else {
            const video = $('<video class="index_video" nopreload loop="loop" autoplay="autoplay" muted>');
            this.preloaderBackgrounds.htmlParams.forEach((param) => {
                video.append(`<source src="${param.src}" type="${param.type}"/>`);
            });
            this.preloaderContainer.append(video);
        }
    }

    private getCachedPreloaderType(): PreloaderBackgroundType {
        const cachedPreloaderType = this.storage.get<PreloaderBackgroundType>(CacheKeys.PRELOADER_TYPE);
        return cachedPreloaderType || PreloaderBackgroundType.Default;
    }

    private savePreloaderTypeToCache(preloaderType: PreloaderBackgroundType) {
        if (preloaderType === PreloaderBackgroundType.Default) {
            this.storage.delete(CacheKeys.PRELOADER_TYPE);
        } else {
            this.storage.set<PreloaderBackgroundType>(CacheKeys.PRELOADER_TYPE, preloaderType);
        }
        this.currentType = preloaderType;
    }
}
